import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import { API_BASE2 } from "./config"

//pass new generated access token here
const token = accessToken

//apply base url for axios
const API_URL = API_BASE2

const axiosApi = axios.create({
  baseURL: API_URL,
  
})

axiosApi.defaults.headers.common["Authorization"] = token

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export async function get2(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data)
}

export async function post2(url, data, config ) {
  return axiosApi
    .post(url, data, config)
    .then((response) => response.data)
}

export async function put2(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
}

export async function del2(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data)
}
